<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ppp-differentpaths002htmltitle">
<p class="bk">Different Paths</p>
<p class="bkau">Judy Clemens</p>
<p class="bkau1"><a class="calibre2" href="http://www.judyclemens.com" target="_blank">www.judyclemens.com</a></p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="bkpub"><img alt="" class="calibre3" src="OEBPS/images/ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-differentpaths002.vue?308da3e1